@if (type() === 'recipe') {
  @if (data().recipeEntities[id()]; as recipe) {
    <div class="title">{{ recipe.name }}</div>
    <ng-container
      *ngTemplateOutlet="recipeProcess; context: { recipe }"
    ></ng-container>
  }
} @else {
  @if (data().itemEntities[id()]; as item) {
    <div class="title">{{ item.name }}</div>
    @if (
      (type() === 'item' || type() === 'technology') &&
        data().itemRecipeIds[id()].length === 1 &&
        data().recipeEntities[data().itemRecipeIds[id()][0]];
      as recipe
    ) {
      <ng-container *ngTemplateOutlet="recipeProcess; context: { recipe }">
      </ng-container>
    }
    @if (
      type() === 'technology' && data().technologyEntities[id()].prerequisites;
      as prerequisites
    ) {
      <div class="mt-1">{{ 'data.prerequisites' | translate }}</div>
      <div>
        @for (prerequisite of prerequisites; track prerequisite) {
          <i [class]="prerequisite | iconSmClass"> </i>
        }
      </div>
    }
  }
  @if (type() === 'beacon' && data().beaconEntities[id()]; as beacon) {
    <table>
      <tr>
        <td>{{ 'data.efficiency' | translate }}</td>
        <td>{{ beacon.effectivity | round }}</td>
      </tr>
      <tr>
        <td>{{ 'data.modules' | translate }}</td>
        <td>{{ beacon.modules }}</td>
      </tr>
      <tr>
        <td>{{ 'data.range' | translate }}</td>
        <td>{{ beacon.range }}</td>
      </tr>
      @if (beacon.type) {
        <tr>
          <td>{{ 'data.energySource' | translate }}</td>
          <td>{{ beacon.type }}</td>
        </tr>
      }
      @if (beacon.usage) {
        <tr>
          <td>{{ 'data.energyConsumption' | translate }}</td>
          <td>{{ beacon.usage | usage }}</td>
        </tr>
      }
      @if (beacon.disallowedEffects) {
        <tr>
          <td>{{ 'data.disallowedEffects' | translate }}</td>
          <td>{{ beacon.disallowedEffects.join(', ') }}</td>
        </tr>
      }
      @if (beacon.size) {
        <tr>
          <td>{{ 'data.dimensions' | translate }}</td>
          <td>{{ beacon.size[0] }}×{{ beacon.size[1] }}</td>
        </tr>
      }
    </table>
  }
  @if (type() === 'belt' && data().beltEntities[id()]; as belt) {
    <table>
      <tr>
        <td>{{ 'data.speed' | translate }}</td>
        <td>
          {{ beltSpeedTxt()[id()] }}{{ dispRateInfo().suffix | translate }}
        </td>
      </tr>
    </table>
  }
  @if (
    type() === 'cargo-wagon' && data().cargoWagonEntities[id()];
    as cargoWagon
  ) {
    <table>
      <tr>
        <td>{{ 'data.storageSize' | translate }}</td>
        <td>{{ cargoWagon.size }}</td>
      </tr>
    </table>
  }
  @if (
    type() === 'fluid-wagon' && data().fluidWagonEntities[id()];
    as fluidWagon
  ) {
    <table>
      <tr>
        <td>{{ 'data.fluidCapacity' | translate }}</td>
        <td>{{ fluidWagon.capacity }}</td>
      </tr>
    </table>
  }
  @if (type() === 'fuel' && data().fuelEntities[id()]; as fuel) {
    <table>
      <tr>
        <td>{{ 'data.fuelCategory' | translate }}</td>
        <td>{{ fuel.category }}</td>
      </tr>
      <tr>
        <td>{{ 'data.fuelValue' | translate }}</td>
        <td>{{ fuel.value | round }} MJ</td>
      </tr>
    </table>
  }
  @if (type() === 'machine' && data().machineEntities[id()]; as machine) {
    <table>
      @if (machine.speed && data().game !== Game.CaptainOfIndustry) {
        <tr>
          <td>{{ 'data.craftingSpeed' | translate }}</td>
          <td>{{ machine.speed | round }}</td>
        </tr>
      }
      @if (machine.modules) {
        <tr>
          <td>{{ 'data.modules' | translate }}</td>
          <td>{{ machine.modules }}</td>
        </tr>
      }
      @if (machine.disallowedEffects) {
        <tr>
          <td>{{ 'data.disallowedEffects' | translate }}</td>
          <td>{{ machine.disallowedEffects.join(', ') }}</td>
        </tr>
      }
      @if (machine.type) {
        <tr>
          <td>{{ 'data.energySource' | translate }}</td>
          <td>{{ machine.type }}</td>
        </tr>
      }
      @if (machine.fuelCategories) {
        <tr>
          <td>{{ 'data.fuelCategories' | translate }}</td>
          <td>{{ machine.fuelCategories.join(', ') }}</td>
        </tr>
      }
      @if (machine.fuel) {
        <tr>
          <td>{{ 'data.fuel' | translate }}</td>
          <td>{{ machine.fuel }}</td>
        </tr>
      }
      @if (machine.usage && machine.usage.nonzero()) {
        <tr>
          <td>{{ 'data.energyConsumption' | translate }}</td>
          <td>{{ machine.usage | usage }}</td>
        </tr>
      }
      @if (machine.drain && machine.drain.nonzero()) {
        <tr>
          <td>{{ 'data.energyDrain' | translate }}</td>
          <td>{{ machine.drain | usage }}</td>
        </tr>
      }
      @if (machine.pollution && machine.pollution.nonzero()) {
        <tr>
          <td>{{ 'data.pollution' | translate }}</td>
          <td>{{ machine.pollution | round }}/m</td>
        </tr>
      }
      @if (machine.size) {
        <tr>
          <td>{{ 'data.dimensions' | translate }}</td>
          <td>{{ machine.size[0] }}×{{ machine.size[1] }}</td>
        </tr>
      }
      @if (machine.silo) {
        <tr>
          <td>{{ 'data.rocketPartsRequired' | translate }}</td>
          <td>{{ machine.silo.parts | round }}</td>
        </tr>
        <tr>
          <td>{{ 'data.rocketLaunchTime' | translate }}</td>
          <td>{{ machine.silo.launch | round }}s</td>
        </tr>
      }
    </table>
    @if (machine.consumption) {
      <div
        class="d-flex align-items-center justify-content-center flex-wrap mt-2"
      >
        @for (input of machine.consumption | keyvalue; track input.key) {
          <i [class]="input.key | iconSmClass">
            <span>{{ input.value | round }}</span>
          </i>
        }
      </div>
    }
  }
  @if (type() === 'module' && data().moduleEntities[id()]; as module) {
    <table>
      @if (module.consumption && module.consumption.nonzero()) {
        <tr>
          <td>{{ 'data.energyConsumption' | translate }}</td>
          <td>{{ module.consumption | bonusPercent }}</td>
        </tr>
      }
      @if (module.speed && module.speed.nonzero()) {
        <tr>
          <td>{{ 'data.speed' | translate }}</td>
          <td>{{ module.speed | bonusPercent }}</td>
        </tr>
      }
      @if (module.productivity && module.productivity.nonzero()) {
        <tr>
          <td>{{ 'data.productivity' | translate }}</td>
          <td>{{ module.productivity | bonusPercent }}</td>
        </tr>
      }
      @if (module.pollution && module.pollution.nonzero()) {
        <tr>
          <td>{{ 'data.pollution' | translate }}</td>
          <td>{{ module.pollution | bonusPercent }}</td>
        </tr>
      }
      @if (module.sprays && module.sprays.nonzero()) {
        <tr>
          <td>{{ 'data.sprays' | translate }}</td>
          <td>{{ module.sprays | round }}</td>
        </tr>
      }
    </table>
  }
  @if (type() === 'pipe' && data().beltEntities[id()]; as pipe) {
    <table>
      <tr>
        <td>{{ 'data.flowRate' | translate }}</td>
        <td>
          {{ beltSpeedTxt()[id()] }}{{ dispRateInfo().suffix | translate }}
        </td>
      </tr>
    </table>
  }
}
<ng-template #recipeProcess let-recipe="recipe">
  @if (data().recipeEntities[recipe.id]; as recipe) {
    <div
      class="d-flex align-items-center justify-content-center flex-wrap mt-2"
    >
      <i [class]="'time' | iconSmClass"
        ><span>{{ recipe.time }}</span></i
      >
      @for (input of recipe.in | keyvalue; track input.key) {
        <i [class]="input.key | iconSmClass"
          ><span>{{ input.value | round }}</span></i
        >
      }
      <i class="m-1 me-2 fa-solid fa-arrow-right"></i>
      @for (output of recipe.out | keyvalue; track output.key) {
        <i [class]="output.key | iconSmClass"
          ><span>{{ output.value | round }}</span></i
        >
      }
    </div>
    <div class="mt-1">{{ 'data.producers' | translate }}</div>
    <div>
      @for (producer of recipe.producers; track producer) {
        <i [class]="producer | iconSmClass"></i>
      }
    </div>
  }
</ng-template>
